module.exports = __webpack_public_path__ + "static/media/creditCardIcon.4f73bbba.svg";